import { render, staticRenderFns } from "./Schuljobs.vue?vue&type=template&id=3ea2e812&scoped=true"
import script from "./Schuljobs.vue?vue&type=script&lang=js"
export * from "./Schuljobs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea2e812",
  null
  
)

export default component.exports